import * as universal_hooks from '../../../src/hooks.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59')
];

export const server_loads = [3,2];

export const dictionary = {
		"/(site)": [~30,[3],[4]],
		"/(site)/about-me": [31,[3],[4]],
		"/(site)/academy": [~32,[3],[4]],
		"/(admin)/admin": [~5,[2]],
		"/(admin)/admin/devis": [~6,[2]],
		"/(admin)/admin/exit-intent": [~7,[2]],
		"/(admin)/admin/logout": [~8,[2]],
		"/(admin)/admin/posts": [~9,[2]],
		"/(admin)/admin/posts/new": [~11,[2]],
		"/(admin)/admin/posts/[slug]": [~10,[2]],
		"/(admin)/admin/products": [~12,[2]],
		"/(admin)/admin/products/new": [17,[2]],
		"/(admin)/admin/products/[id]": [13,[2]],
		"/(admin)/admin/products/[id]/download": [14,[2]],
		"/(admin)/admin/products/[id]/edit": [~15,[2]],
		"/(admin)/admin/products/[id]/upload": [~16,[2]],
		"/(admin)/admin/projects": [~18,[2]],
		"/(admin)/admin/projects/[id]": [~19,[2]],
		"/(admin)/admin/series": [~20,[2]],
		"/(admin)/admin/series/new": [~21,[2]],
		"/(admin)/admin/settings": [~22,[2]],
		"/(admin)/admin/stats": [~23,[2]],
		"/(admin)/admin/subscribers": [~24,[2]],
		"/(admin)/admin/testimonials": [~25,[2]],
		"/(admin)/admin/thank-you": [~26,[2]],
		"/(admin)/admin/tools": [~27,[2]],
		"/(site)/blog": [~33,[3],[4]],
		"/(site)/blog/[slug]": [~34,[3],[4]],
		"/(site)/case-studies": [~35,[3],[4]],
		"/(site)/case-studies/[slug]": [~36,[3],[4]],
		"/(site)/checkout/[slug]": [~37,[3],[4]],
		"/(site)/contact": [38,[3],[4]],
		"/(site)/devis": [39,[3],[4]],
		"/(site)/faq": [40,[3],[4]],
		"/(site)/legals": [41,[3],[4]],
		"/(auth)/login": [~29],
		"/parleria": [59],
		"/(site)/privacy-policy": [42,[3],[4]],
		"/(site)/products": [~43,[3],[4]],
		"/(site)/products/[slug]": [~44,[3],[4]],
		"/(site)/projects": [~45,[3],[4]],
		"/(site)/projects/[slug]": [~46,[3],[4]],
		"/(site)/resources": [~47,[3],[4]],
		"/(site)/resources/[slug]": [~48,[3],[4]],
		"/(site)/roi-simulator": [~49,[3],[4]],
		"/(site)/series": [~50,[3],[4]],
		"/(site)/series/[slug]": [~51,[3],[4]],
		"/(site)/solutions": [~52,[3],[4]],
		"/(site)/stats": [~53,[3],[4]],
		"/(site)/terms-of-use": [54,[3],[4]],
		"/(after-submit)/thank-you": [~28],
		"/(site)/thank": [55,[3],[4]],
		"/(site)/toolbox": [~56,[3],[4]],
		"/(site)/toolbox/[slug]": [~57,[3],[4]],
		"/(site)/tools/[slug]": [~58,[3],[4]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: universal_hooks.reroute || (() => {}),
	transport: universal_hooks.transport || {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';